'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.camelCase = camelCase;
exports.Asset = Asset;
exports.validateAccountName = validateAccountName;
exports.fitImageToSize = fitImageToSize;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var snakeCaseRe = /_([a-z])/g;
function camelCase(str) {
  return str.replace(snakeCaseRe, function (_m, l) {
    return l.toUpperCase();
  });
}

function toFixedTrunc(x, n) {
  var v = (typeof x === 'string' ? x : x.toString()).split('.');
  if (n <= 0) return v[0];
  var f = v[1] || '';
  if (f.length > n) return v[0] + '.' + f.substr(0, n);
  while (f.length < n) {
    f += '0';
  }return v[0] + '.' + f;
}

var _Asset = function () {
  function _Asset(amount, precision, symbol) {
    _classCallCheck(this, _Asset);

    if (precision && symbol) {
      this._amount = amount;
      this._precision = precision;
      this._symbol = symbol;
      return;
    }
    var str = amount;
    var asset_parts = str.split(' ');
    this._precision = asset_parts[0].split('.')[1].length;
    this._amount = parseFloat(asset_parts[0]) * Math.pow(10, this._precision);
    this._symbol = asset_parts[1];
  }

  _createClass(_Asset, [{
    key: 'toString',
    value: function toString() {
      var decPlaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      return toFixedTrunc(this.amountFloat, decPlaces !== undefined ? decPlaces : this._precision) + ' ' + this._symbol;
    }
  }, {
    key: 'amount',
    get: function get() {
      return this._amount;
    },
    set: function set(value) {
      this._amount = value;
    }
  }, {
    key: 'amountFloat',
    get: function get() {
      return this._amount / Math.pow(10, this._precision);
    },
    set: function set(value) {
      this._amount = value * Math.pow(10, this._precision);
    }
  }, {
    key: 'precision',
    get: function get() {
      return this._precision;
    },
    set: function set(value) {
      this._precision = value;
    }
  }, {
    key: 'symbol',
    get: function get() {
      return this._symbol;
    },
    set: function set(value) {
      this._symbol = value;
    }
  }, {
    key: 'isUIA',
    get: function get() {
      return this._symbol != 'GOLOS' && this._symbol != 'GBG' && this._symbol != 'GESTS';
    }
  }]);

  return _Asset;
}();

function Asset() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_Asset, [null].concat(args)))();
}

function validateAccountName(value) {
  var i = void 0,
      label = void 0,
      len = void 0,
      suffix = void 0;
  var res = { error: null, msg: '' };

  suffix = "Account name should ";

  if (!value) {
    res.msg = suffix + "not be empty.";
    res.error = 'account_name_should_not_be_empty';
    return res;
  }

  var length = value.length;
  if (length < 3) {
    res.msg = suffix + "be longer.";
    res.error = 'account_name_should_be_longer';
    return res;
  }
  if (length > 16) {
    res.msg = suffix + "be shorter.";
    res.error = 'account_name_should_be_shorter';
    return res;
  }

  if (/\./.test(value)) {
    suffix = "Each account segment should ";
  }
  var ref = value.split(".");
  for (i = 0, len = ref.length; i < len; i++) {
    label = ref[i];
    if (!/^[a-z]/.test(label)) {
      res.msg = suffix + "start with a letter.";
      res.error = 'each_account_segment_should_start_with_a_letter';
      return res;
    }
    if (!/^[a-z0-9-]*$/.test(label)) {
      res.msg = suffix + "have only letters, digits, or dashes.";
      res.error = 'each_account_segment_should_have_only_letters_digits_or_dashes';
      return res;
    }
    if (/--/.test(label)) {
      res.msg = suffix + "have only one dash in a row.";
      res.error = 'each_account_segment_should_have_only_one_dash_in_a_row';
      return res;
    }
    if (!/[a-z0-9]$/.test(label)) {
      res.msg = suffix + "end with a letter or digit.";
      res.error = 'each_account_segment_should_end_with_a_letter_or_digit';
      return res;
    }
    if (!(label.length >= 3)) {
      res.msg = suffix + "be longer";
      res.error = 'each_account_segment_should_be_longer';
      return res;
    }
  }

  return res;
}

function fitImageToSize(width, height, goodWidth, goodHeight) {
  var overWidth = width / goodWidth;
  var overHeight = height / goodHeight;

  if (overWidth <= 1 && overHeight <= 1) {
    return { width: width, height: height };
  }

  var proportion = width / height;

  if (overWidth > overHeight) {
    width = goodWidth;
    height = Math.round(width / proportion);
  } else {
    height = goodHeight;
    width = Math.round(height * proportion);
  }
  return { width: width, height: height };
}